import 'smart-app-banner/dist/smart-app-banner.css';
import * as SmartBanner from 'smart-app-banner/dist/smart-app-banner.js';

const sub = document.querySelector('.page');
sub.classList.add('page_notfound');

new SmartBanner({ // eslint-disable-line no-new
    daysHidden: 15,
    daysReminder: 90,
    appStoreLanguage: 'us',
    title: 'Blossom - Plant Identifier',
    author: 'Conceptiv Apps LLC',
    button: 'View'
});
